//  上线之后需要修改这个值为false


export const isTest = false;

export const defaultAvatar = `${import.meta.env.BASE_URL}img/user/default-avatar.png`;

export const anchorDefaultAvatar = `${import.meta.env.BASE_URL}img/user/anchor-default-avatar.png`;

// logo 改为从后端 platform_config.logoUrl 动态获取（见 app-store.js fetchApp）
// logoStyle 保留为静态样式常量
export const logoStyle = {
    width: 232,
    height: 68
}

export const allGoodsImg = `${import.meta.env.BASE_URL}img/all-goods/goods.png`

export const liveGoodsOnTableImg = `${import.meta.env.BASE_URL}img/live/goods-on-table.png`

export const liveTableImg = `${import.meta.env.BASE_URL}img/live/table.png`

export const liveFloatIcon = `${import.meta.env.BASE_URL}img/live/float-icon.png`

export const goodsDefaultImg = `${import.meta.env.BASE_URL}img/goods/goods-default-img.png`

export const aboutUsImg1 = `${import.meta.env.BASE_URL}img/about-us/img1.jpg`